import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface IntroProps {
  headline: string;
  keywords: string[];
  introIcon?: string;
  frame: number;
  fps: number;
}

export const RetroTerminalIntro: React.FC<IntroProps> = ({
  headline,
  keywords,
  introIcon,
  frame,
  fps,
}) => {
  return (
          <div
            style={{
              width: "100%",
              background: "#080c08",
              border: "2px solid #224422",
              borderRadius: "16px",
              boxShadow:
                "0 20px 40px rgba(0,0,0,0.6), 0 0 15px rgba(57, 255, 20, 0.05)",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Terminal Top Window Bar */}
            <div
              style={{
                height: "40px",
                background: "#121b12",
                borderBottom: "2px solid #224422",
                display: "flex",
                alignItems: "center",
                padding: "0 16px",
                gap: "8px",
              }}
            >
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#ff5f56",
                }}
              />
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#ffbd2e",
                }}
              />
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#27c93f",
                }}
              />
              <div
                style={{
                  marginLeft: "12px",
                  fontFamily: "'JetBrains Mono', monospace",
                  color: "#39ff14",
                  fontSize: "12px",
                  fontWeight: 700,
                  opacity: 0.8,
                }}
              >
                bash --intro-hook.sh
              </div>
            </div>

            {/* Terminal Hook Content */}
            <div
              style={{
                padding: "40px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  color: "rgba(57, 255, 20, 0.4)",
                  fontSize: "15px",
                  fontWeight: 700,
                }}
              >
                guest@stdout:~$ cat intro.txt
              </div>

              <h1
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "52px",
                  fontWeight: 700,
                  lineHeight: 1.3,
                  color: "#39ff14",
                  letterSpacing: "-0.5px",
                  textShadow: "0 0 10px rgba(57, 255, 20, 0.3)",
                }}
              >
                &gt; {headline}
                <span
                  style={{
                    display: "inline-block",
                    width: "12px",
                    height: "26px",
                    background: "#39ff14",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                    opacity: Math.floor(frame / 10) % 2 === 0 ? 1 : 0,
                  }}
                />
              </h1>
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
